import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Scraper() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const plan = user?.plan || 'Basic';

  if (plan !== 'Pro' && plan !== 'Pro+') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 140px)', gap: 20, textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#534AB7,#1D9E75)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="ti ti-world-search" style={{ fontSize: 28, color: '#fff' }} aria-hidden="true" />
        </div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Lead Scraper</div>
          <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 380, lineHeight: 1.7, marginBottom: 24 }}>Upgrade to Pro or Pro+ to unlock the Lead Scraper.</div>
          <button onClick={() => navigate('/dashboard/settings')} style={{ padding: '10px 28px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg,#534AB7,#1D9E75)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Upgrade Plan</button>
        </div>
      </div>
    );
  }

  const scraperLabel = plan === 'Pro+' ? 'Access Pro Scraper' : 'Access Basic Scraper';
  const scraperDesc = plan === 'Pro+'
    ? 'You have Pro scraper access — find and import self-employed leads by industry and location.'
    : 'You have Basic scraper access — find and import self-employed leads by industry and location.';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 140px)', gap: 20, textAlign: 'center' }}>
      <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#534AB7,#1D9E75)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <i className="ti ti-world-search" style={{ fontSize: 28, color: '#fff' }} aria-hidden="true" />
      </div>
      <div>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Lead Scraper</div>
        <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 380, lineHeight: 1.7, marginBottom: 24 }}>{scraperDesc}</div>
        <a
          href="https://sladeiq.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 32px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg,#534AB7,#1D9E75)', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', textDecoration: 'none', boxShadow: '0 4px 15px rgba(83,74,183,0.3)' }}
        >
          <i className="ti ti-external-link" style={{ fontSize: 15 }} aria-hidden="true" />
          {scraperLabel}
        </a>
      </div>
    </div>
  );
}
